import NestedRouteComponent from 'router/nestedViews/NestedRouteComponent';
import wrapLegacyRoute from 'router/legacy/wrapLegacyRoute';
import translation from 'translation';

const accountClosureRoutes = [
  {
    path: 'closure',
    meta: {
      routeName: {
        segmentName: () => translation.tr('Closure')
      }
    },
    component: NestedRouteComponent,
    children: [
      {
        path: 'report',
        name: 'closureReport',
        meta: {
          routeName: {
            segmentName: () => translation.tr('Closure report')
          },
          permissions: ['READ_CLOSURE_REPORT']
        },
        component: wrapLegacyRoute('closureController', 'closureReport')
      },
      {
        path: 'revise/reports',
        name: 'reviseReports',
        meta: {
          routeName: {
            segmentName: () => translation.tr('Revise reports')
          },
          permissions: ['READ_REVISE_REPORTS']
        },
        component: wrapLegacyRoute('closureController', 'reviseReports')
      },
      {
        path: 'broker/reports',
        name: 'brokerReports',
        meta: {
          routeName: {
            segmentName: () => translation.tr('Import Yandex acts')
          },
          permissions: ['READ_BROKER_REPORTS']
        },
        component: wrapLegacyRoute('closureController', 'brokerReports')
      },
      {
        path: 'placements/unlinked',
        name: 'brokerPlacementsUnlinkedList',
        meta: {
          routeName: {
            segmentName: () => translation.tr('Broker unlinked placements')
          },
          permissions: ['READ_BROKER_PLACEMENTS_UNLINKED']
        },
        component: wrapLegacyRoute('closureController', 'placementsUnlinked')
      },
      {
        path: 'placements/excluded',
        name: 'brokerPlacementsExcludedList',
        meta: {
          routeName: {
            segmentName: () => translation.tr('Broker excluded placements')
          },
          permissions: ['READ_BROKER_PLACEMENTS_EXCLUDED']
        },
        component: wrapLegacyRoute('closureController', 'placementsExcluded')
      },
      {
        path: 'placements/spending',
        name: 'closurePlacementsSpending',
        meta: {
          routeName: {
            segmentName: () => translation.tr('Placements spending')
          },
          permissions: ['READ_PLACEMENTS_SPENDING']
        },
        component: wrapLegacyRoute('closureController', 'placementsSpending')
      },
      {
        path: 'accounting/report',
        name: 'accountingReport',
        meta: {
          routeName: {
            segmentName: () => translation.tr('Accounting report')
          },
          permissions: ['READ_ACCOUNTING_REPORT']
        },
        component: wrapLegacyRoute('closureController', 'accountingReport')
      },
      {
        path: 'bookingregistry/report',
        name: 'bookingRegistryReport',
        meta: {
          routeName: {
            segmentName: () => translation.tr('Booking registry report')
          },
          permissions: ['READ_RORE_BOOKING_REGISTRY_REPORT']
        },
        component: wrapLegacyRoute('closureController', 'bookingRegistryReport')
      }
    ]
  }
];

export default accountClosureRoutes;
